import {CatalogImageProps} from "@/app/_components/CourseShelf";
import StrapiImage from "@/app/_components/StrapiImage";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import clsMerge from "@/app/util/clsMerge";

const LowerCatalogFillImage: FCWithHTMLAttributes<CatalogImageProps> = ({
	image,
	imageMd,
	imageLg,
	className,
	imageClass,
	imageClassMd,
	imageClassLg,
}) => {
	return (
		<div
			className={clsMerge(
				"relative max-h-[9.4rem] w-full overflow-hidden rounded-[2.5rem] shadow-inner sm:h-[9.4rem] md:h-[12.9rem] md:max-h-[unset] md:w-max xl:h-[18.8rem] xl:border-4 xl:border-solid xl:border-white",
				className
			)}
		>
			<StrapiImage
				className={clsMerge(
					"w-full sm:absolute sm:top-2/4 sm:h-fit sm:-translate-y-2/4 md:hidden",
					imageClass
				)}
				image={image}
			/>
			<StrapiImage
				className={clsMerge(
					"hidden h-full w-[revert-layer] md:block xl:hidden",
					imageClassMd
				)}
				image={imageMd}
			/>
			<StrapiImage
				className={clsMerge(
					"hidden h-full w-[revert-layer] xl:block",
					imageClassLg
				)}
				image={imageLg}
			/>
		</div>
	);
};

export default LowerCatalogFillImage;
